var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back-btn p-0",style:({position: _vm.position}),attrs:{"title":"Go back","aria-label":"Go back"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }